import script from "./LessonPlanEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./LessonPlanEditor.vue?vue&type=script&setup=true&lang=js"

import "./LessonPlanEditor.vue?vue&type=style&index=0&id=6db2e85a&lang=less&scoped=true"
script.__scopeId = "data-v-6db2e85a"

export default script